<template lang='pug' src='./get-started.pug'></template>

<script>
import AaoicLink from 'components/custom/custom-get-start-aaoic-link/custom-get-start-aaoic-link'
import HealthHistoryForm from 'components/custom/custom-get-start-health-history-form/custom-get-start-health-history-form'
import Financial from 'components/custom/custom-get-start-financial/custom-get-start-financial'
import FirstVisit from 'components/custom/custom-get-start-first-visit/custom-get-start-first-visit'
import Form from 'components/forms/form'
import FormSection from 'components/custom/custom-get-start-form-section/custom-get-start-form-section'
import Hero from 'components/hero/hero'
import Intro from 'components/custom/custom-intro/custom-intro'
import Loader from 'components/loader/loader'
import Testimonial from 'components/block/block-testimonial/block-testimonial'

export default {
  name: 'get-started',
  computed: {
    props () {
      return this.$store.state.pages['get-started']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    AaoicLink,
    Financial,
    FirstVisit,
    Form,
    FormSection,
    Hero,
    Intro,
    Loader,
    Testimonial,
    HealthHistoryForm
  }
}
</script>



// WEBPACK FOOTER //
// get-started.vue?57a1ca42